export enum rolesPortail {
  admin = 'admin_portail',
}
